import { render, staticRenderFns } from "./BancaFarmaciViewComponent.vue?vue&type=template&id=0b9015fb"
import script from "./BancaFarmaciViewComponent.vue?vue&type=script&lang=js"
export * from "./BancaFarmaciViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports